import React from "react";
import {
  options_state_valid,
  options_state_new,
} from "../Apollo_styles";

// import Select from "react-select";
import Select from '@material-ui/core/Select';

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import {useForm} from "react-hook-form";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from "@material-ui/core/Typography";
// import {useForm} from "react-hook-form";


export type PropsSelectStatus = {
  defaultValue: number  // 初期選択値
  value: number         // 選択値
  setValue: any         // 選択値セット関数
  isDisabled: boolean   // 不活化
  required: boolean     // 必須
  register: boolean     // 登録:true 編集:false
}

interface SelectStatusProps {
  propsSelect: PropsSelectStatus
};

// ステータス選択セレクトボックス表示
export default function ApolloSelectStatus(props: SelectStatusProps) {

  const {
    defaultValue,
    value,
    setValue,
    isDisabled,
    required,
    register,
  } = props.propsSelect;

  const {errors,} = useForm();

  if (!value) {
    setValue(defaultValue);
  }

  const handleChangeStatus = (event: any) => {
    setValue(event.target.value);
  };

  return (
    <div>
      <InputLabel id="status">
        <Typography variant="caption">
        ステータス *
        </Typography>
      </InputLabel>
      <FormControl error={errors.status ? true : false} fullWidth>
        <Select
          labelId="status"
          id="status"
          name="status"
          key={value ? "Loaded" : "Loading"}
          value={value}
          defaultValue={defaultValue}
          onChange={handleChangeStatus}
          disabled={isDisabled}
          required={required}
        >
          {
            register ?
            options_state_valid.map((status: any, index: any) =>
              <MenuItem value={status.value}>{status.label}</MenuItem>
            )
            :
            options_state_new.map((status: any, index: any) =>
              <MenuItem value={status.value}>{status.label}</MenuItem>
            )
          }
        </Select>
        <FormHelperText>{errors.status && errors.status.message}</FormHelperText>
      </FormControl>
    </div>
  )
}
